import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import { COLORS } from 'theme';

const WarningCircleIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm.5 15h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5Zm-.5-4a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1Z"
      fill={props.sx?.color || COLORS.kinetikBlack}
    />
  </SvgIcon>
);

WarningCircleIcon.propTypes = {
  sx: PropTypes.object,
};

export default WarningCircleIcon;
